export const signUpTypes = {
    SIGN_UP_REQUEST: 'USER_SIGN_UP_REQUEST',
    SIGN_UP_SUCCESS: 'USER_SIGN_UP_SUCCESS',
    SIGN_UP_FAILURE: 'USER_SIGN_UP_FAILURE',

    SET_ERROR: 'USER_SIGN_UP_SET_ERROR',
    SET_ERRORS: 'USER_SIGN_UP_SET_ERRORS',
    REMOVE_ERRORS: 'USER_SIGN_UP_REMOVE_ERRORS',

    GENERAL_ERROR: "USER_SIGN_UP_GENERAL_ERROR",
    UNKNOWN_ERROR: "USER_SIGN_UP_UNKNOWN_ERROR",
};
